






















































import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/AccountSetup.scss';
import { validationMixin } from 'vuelidate';
import { ObjectFactory } from '../../config/objectFactory';
import { MedTransGoConstants } from '@/util/constants';
import AddDriverModal from './../modal/AddDriverModal.vue';
import UploadDriverModal from './UploadDriverModal.vue';
import { CommonUtils } from '@/util/commonUtils';
import { ApiRequest, ProfileRequest, QueryRecordsRequest } from '@/types/request';
import { DriverProfile } from '@/types/response';
import DataTable from '@/components/DataTable.vue';
import AddTransporterDriverDetailsModal from '../modal/AddTransporterDriverDetailsModal.vue';
import UploadDriverDocumentsModal from '../UploadDriverDocumentsModal.vue';
import { Driver } from '@/types/entity';

// tslint:disable-next-line: no-var-requires
const DriversTable = require('../../datatable/DriversTable.json');

@Component({
  mixins: [validationMixin],
  components: {
    AddDriverModal,
    UploadDriverModal,
    DataTable,
    AddTransporterDriverDetailsModal,
    UploadDriverDocumentsModal,
  },
  props: {
    request: Object,
  },
  validations() {
    const validations = {
      request: {},
    };
    return validations;
  },
})
export default class AddDrivers extends Vue {
  private show = false;
  private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
  private showDriverModal = false;
  private showUploadDriverModal = false;
  private fileName = '';
  private transporterId: any;
  private driverStart = 0;
  private driversDataSource = DriversTable;
  private isBLSProvider = false;
  private isNextDisabled = true;
  private transporterDriverDetailsForm = false;
  private showUploadDocument = false;
  private driverId: any;
  private totalDocs = 8;
  private isTransporterAsDriver = true;
  public mounted() {
    this.$props.request.isStepADValid = false;
    if (this.sessionInfo.scopes.includes('transporter')) {
      const profileRequest = this.getProfileRequest();
      profileRequest.questionnaires.find((element: any) => {
            if (element.question === 'Do you provide Basic Life Support (BLS) Transportation Services?' &&
                element.answer
              ) {
                this.isBLSProvider = true;
            }
        });
      profileRequest.isStepADValid = false;
      if (!profileRequest.isStepQnValid) {
        this.$router.push({ name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME });
      }
    } else {
      this.$router.push({ name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME });
    }
    this.transporterId = this.$props.request.transporterId;
    this.getDrivers();
  }

  private async save() {
    this.$router.push({ name: MedTransGoConstants.VIEW_HEALTH_INSURANCE_INFO_NAME });
    this.$props.request.isStepADValid = true;
  }

  private back() {
    this.$router.push({
      name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME,
    });
  }

  private getProfileRequest(): ProfileRequest {
    return this.$props.request as ProfileRequest;
  }

  private async getDrivers(searchString?: string, start?: number) {
    if (typeof start !== 'undefined') {
      this.driverStart = start;
    } else if (this.driverStart > 0) {
      start = this.driverStart;
    }
    if (this.sessionInfo.scopes.includes('transporter') || this.sessionInfo.scopes.includes('dispatcher')) {
      const iHttpService = ObjectFactory.getHttpService();
      const queryRecordsRequest: QueryRecordsRequest = {
        start,
        limit: MedTransGoConstants.PAGINATION_LIMIT,
        order: {
          status: -1,
        },
      };
      const apiRequest: ApiRequest = {
        baseURL: this.$store.state.serverUrl,
        data: queryRecordsRequest,
        url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/list`,
        loaderEvent: {
          show: true,
        },
      };
      const response = await iHttpService.post<DriverProfile[]>(apiRequest);
      if (response.data && response.success) {
        response.data.forEach((element) => {
          if (element.status === 'PENDING_VERIFICATION') {
            element.status = 'Under Review' as any;
          } else if (element.status === 'ACTIVE') {
            element.status = 'Active' as any;
          } else if (element.status === 'DEACTIVATED') {
            element.status = 'Deactive' as any;
          } else if (element.status === 'DEACTIVE') {
            element.status = 'Deactive' as any;
          }
        });
        this.driversDataSource.data = response.data.map((driver) => {
          const uploadedDocs = driver.documents ? driver.documents.length : 0;
          const totalDocs = this.totalDocs || 0;
          const isAllUploaded = uploadedDocs === this.totalDocs;
          return {
              ...driver,
              docsUploadedCount: `${uploadedDocs} / ${totalDocs}`,
              docsUploadedStatus: isAllUploaded,
          };
        });
        if (response.totalCount !== undefined) {
          this.driversDataSource.totalCount = response.totalCount;
        }
        this.isNextDisabled = this.driversDataSource.data.length === 0;
        response.data.find((element) => {
          if (element.id === this.transporterId) {
            this.isTransporterAsDriver = false;
          }
        });
      } else {
        CommonUtils.showError(response);
      }
    }
  }

  private async transporterAsDriverForm() {
    this.transporterDriverDetailsForm = true;
  }

  private uploadDriverDocuments(driver: Driver) {
    this.driverId = driver.id;
    this.showUploadDocument = true;
  }
}
